import { apiRequest } from '../Api/ApiRequest';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function api_getBills() {

  return apiRequest({
    url: '/billing',
    method: 'get',
    headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
  }).then(
    (resp) => resp,
  ).catch(
    (error) => error,
  );

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function api_getBill(id) {

  return apiRequest({
    url: `/billing/${id}`,
    method: 'get',
    headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
  }).then(
    (resp) => resp,
  ).catch(
    (error) => error,
  );

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function api_downloadBillArtifacts(id, documentId) {

  return apiRequest({
    url: `/billing/${id}/artifacts/${documentId}`,
    method: 'get',
    responseType: 'blob',
    headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
  }).then(
    (resp) => resp,
  ).catch(
    (error) => error,
  );

}
